import axios from "axios";
import apiConfig from "../../ApiConfig/apiConfig";

const baseUri = apiConfig.api.baseURL;
const videoBaseUri = process.env.REACT_APP_VIDEO_BASE_URL || baseUri;
const azureBaseUri = process.env.REACT_APP_AZURE_BASE_URL || baseUri;

export const URLS = {
  VIDEO_URI: `${videoBaseUri}/video/api/v1`,
  AUTH_URI:  `${baseUri}/auth/api/v1`,
  AZURE_URI: `${azureBaseUri}/azure/api/v1`,
};

const axiosInstance = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: {
    "content-type": "application/json",
    Accept: "application/json",
  },
});

export const fetchTokenData = () =>
  axiosInstance.post(`${URLS.VIDEO_URI}/video-service/verify-rooms-token`, {
    roomToken: sessionStorage.getItem("roomToken"),
  });

export const getUserToken = (payload: Object, service: string) =>
  axiosInstance.post(`${URLS.VIDEO_URI}/video-service/get-user-token/${service}`, payload);

export const getDoctorUserToken = (scope: string, service: string, consultationId: string) =>
  axiosInstance.post(`${URLS.VIDEO_URI}/video-service/get-doctor-user-token/${service}`, {
    scope,
    consultationId,
    doctorId: localStorage.getItem("doctorId") || undefined,
  });

export const getPatientUserToken = (scope: string, service: string, consultationId: string, roomId?: string) =>
  axiosInstance.post(`${URLS.VIDEO_URI}/video-service/get-patient-user-token/${service}`, {
    scope,
    consultationId,
    roomId,
  });

export const addUserToRoom = (payload: Object) =>
  axiosInstance.post(`${URLS.VIDEO_URI}/video-service/add-user-to-room/azure`, payload);

export const getAzureSignedUrl = (url: string, docName: string, benId: string, docType: string) =>
  axiosInstance.post(`${url}`, { docName, benId, docType });

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Don't intercept login, OTP, refresh-token, or patient-specific requests
    const isAuthRequest =
      originalRequest?.url?.includes("/login") ||
      originalRequest?.url?.includes("/send-otp") ||
      originalRequest?.url?.includes("/auth/refresh-token") ||
      originalRequest?.url?.includes("/verify-rooms-token") ||
      originalRequest?.url?.includes("/get-patient-user-token");

    if (isAuthRequest) {
      return Promise.reject(error);
    }

    // If 401, handle token refresh or redirect
    if (error.response?.status === 401) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        try {
          // refreshToken cookie is httpOnly — browser sends it automatically
          await axiosInstance.post(`${URLS.AUTH_URI}/auth/refresh-token`);
          // Retry the original request with new cookies
          return axiosInstance(originalRequest);
        } catch {
          // Refresh also failed — session is expired, redirect to login
          localStorage.removeItem("doctorId");
          localStorage.removeItem("doctorName");
          localStorage.removeItem("doctorRole");
          if (window.location.pathname !== "/") {
            window.location.href = "/";
          }
        }
      } else {
        // Retried request still returned 401 — clear session and redirect
        localStorage.removeItem("doctorId");
        localStorage.removeItem("doctorName");
        localStorage.removeItem("doctorRole");
        if (window.location.pathname !== "/") {
          window.location.href = "/";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
